import { urls } from "../../urls";

const fetchUnsubscribeData = async (subscriptionId: string, username: string, pageName: string) => {
    const rapbackUrl = urls.RAPBACK
    const url: string = `${process.env.NODE_ENV === "production" ? rapbackUrl : ""}/subscription/unsubscribe/${subscriptionId}?deletion_source=${pageName === "rapback-maintenance" ? "maintenance" : "validation"}&username=${username}`;
    try {
        return await fetch(url, {
            method: "POST",
            credentials: "include"
        })
    } catch (err: any) {
        console.error('error querying rapback unsubscribe: ', err)
        return {
            message: "error",
            status: 400,
            ok: false
        }
    }
}

export default fetchUnsubscribeData